import React from "react";
import SearchInput from "../ui/SearchInput";
import Icon from "../ui/Icon";
import NotificationsBell from "./NotificationsBell";
import QuickChatButton from "../../merchantChat/QuickChatButton.jsx";
import ThemeSwitch from "./ThemeSwitch";
import "./AppTopbar.scss";

// Fontaine M28 — AppTopbar (laptop): search (⌘K opens the command palette) ·
// theme · quick chat · notifications. The account avatar and its menu were
// removed on 2026-09-25: Profile joined the sidebar above Settings, and Store
// settings and Log out were already there. Store context lives in the sidebar.
// Board 2 Q2 = A. Page titles are NOT here — they live in PageHeader inside the page.

export default function AppTopbar() {

  return (
    <header className="ft-topbar" role="banner">
      <div className="ft-topbar__search">
        <SearchInput
          auto
          size="md"
          commandPalette
          placeholder="Search listings, orders, people…"
          aria-label="Search"
        />
      </div>
      <div className="ft-topbar__actions">
        <ThemeSwitch compact size="md" />
        {/* Quick chat lives beside the bell — the bottom-right corner is
            already the onboarding widget + beta reporter. */}
        <QuickChatButton />
        <NotificationsBell />
        {/* No account avatar. Everything behind it — Profile, Store settings,
            Log out — is a sidebar destination now, and a menu whose every item
            is two inches to the left is a second place to look rather than a
            shortcut (Alex, 2026-09-25). */}
      </div>
    </header>
  );
}
